import { render, staticRenderFns } from "./EditAktivitasTambahan.vue?vue&type=template&id=18b81b8d&scoped=true&lang=html&"
import script from "./EditAktivitasTambahan.vue?vue&type=script&lang=js&"
export * from "./EditAktivitasTambahan.vue?vue&type=script&lang=js&"
import style0 from "./EditAktivitasTambahan.vue?vue&type=style&index=0&id=18b81b8d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b81b8d",
  null
  
)

export default component.exports